import { gql } from '@apollo/client';

const INBOX_DETAILS_QUERY = gql`
  query inboxDetails($id: ID!) {
    report(id: $id) {
      id
      reportId
      type
      start
      stop
      statusReport
      lastStatusReportAt
      study {
        id
        friendlyId
        externalSource {
          provider
          externalId
        }
        deviceId
        start
        status
        stop
        reportDueDate
        info {
          interprettingPhysician {
            id
            firstName
            lastName
          }
          patient {
            firstName
            lastName
            patientId
          }
        }
        studyType
        timezone
        studyTimeOffset
        isNonPhi
        facility {
          id
          name
          contact {
            phone1
            country
            address
            city
            zip
            state
          }
          arrears
          timezone
        }
        isBiofluxDirect
        reports {
          id
          type
          inbox {
            date
          }
        }
        device {
          model
        }
      }
      event {
        id
        friendlyId
        hasClinicData
        comments
      }
      hasSignature
      findings
      physicianInterpretation
      inbox {
        date
        priority
        isReviewed
        isRead
      }
      isArtifactReport
      isNewFormat
      formatVersion
      aiFormatVersion
      profile
      status
      technicianComments
      lastModified
      isRenderingBackground
      reportFindings
      totalStrips
    }
  }
`;

export default INBOX_DETAILS_QUERY;
